var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "result-search-page" } },
    [
      _c("div", { class: _vm.containerClasses }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "search-result-top" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "bottom space-between" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.perPage,
                          expression: "perPage"
                        }
                      ],
                      staticClass: "per-page",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.perPage = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.onFilterChange("perPage", "per_page")
                          }
                        ]
                      }
                    },
                    _vm._l(_vm.per_page_options, function(option) {
                      return _c(
                        "option",
                        { domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(option.text) +
                              "\n                            "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.perRow,
                          expression: "perRow"
                        }
                      ],
                      staticClass: "per-row",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.perRow = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.onFilterChange("perRow", "per_row")
                          }
                        ]
                      }
                    },
                    _vm._l(_vm.vehicles_in_row_options, function(option) {
                      return _c(
                        "option",
                        { domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(option.text) +
                              "\n                            "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.$userIsAdmin()
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "Filter recommended by"
                          },
                          on: {
                            change: function($event) {
                              return _vm.onFilterChange(
                                "recommendedBy",
                                "recommended_by"
                              )
                            }
                          },
                          model: {
                            value: _vm.recommendedBy,
                            callback: function($$v) {
                              _vm.recommendedBy = $$v
                            },
                            expression: "recommendedBy"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "All", value: "all" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "Mine", value: _vm.loggedInUser.id }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.recommendedUsers, function(user) {
                            return _c("el-option", {
                              key: user.id,
                              attrs: { label: user.label, value: user.id }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dateFilter,
                          expression: "dateFilter"
                        }
                      ],
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.dateFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.onFilterChange("dateFilter", "date")
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("Filter by Date")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.dateOptions, function(date) {
                        return [
                          _c(
                            "option",
                            {
                              domProps: {
                                value: date.value,
                                selected: date.value == _vm.dateFilter
                              }
                            },
                            [_vm._v(_vm._s(date.label))]
                          )
                        ]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.addedHourFilter,
                          expression: "addedHourFilter"
                        }
                      ],
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.addedHourFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.onFilterChange("addedHour", "added_hour")
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("Filter by recommended time")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.addedFilterOptions, function(addedHour) {
                        return [
                          _c(
                            "option",
                            {
                              domProps: {
                                value: addedHour.value,
                                selected: addedHour.value == _vm.addedHourFilter
                              }
                            },
                            [_vm._v(_vm._s(addedHour.label))]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "right" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sortOrderBy,
                        expression: "sortOrderBy"
                      }
                    ],
                    attrs: { name: "sorting", id: "sorting" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.sortOrderBy = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.onFilterChange(
                            "sortOrderBy",
                            "sort_order_by"
                          )
                        }
                      ]
                    }
                  },
                  _vm._l(_vm.order_options, function(data, value) {
                    return _c("option", { domProps: { value: value } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(data.text) +
                          "\n                            "
                      )
                    ])
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.total > 0
                ? _c("span", { staticClass: "showing" }, [
                    _c("strong", [_vm._v("Showing")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.from))]),
                    _vm._v("-"),
                    _c("span", [_vm._v(_vm._s(_vm.to))]),
                    _vm._v(" of "),
                    _c("span", [_vm._v(_vm._s(_vm.total))]),
                    _vm._v(
                      "\n                            results\n                        "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-results",
              attrs: { id: "container-results" }
            },
            [
              _vm.recommendedVehicles && _vm.recommendedVehicles.length
                ? [
                    _vm._l(_vm.recommendedVehicles, function(vehicle) {
                      return _c("Vehicle", {
                        key: vehicle.api_id,
                        style: _vm.resultBlockWidth,
                        attrs: {
                          vehicle: vehicle,
                          priceField: "start_price",
                          selected:
                            _vm.selectedVehicles.indexOf(vehicle.api_id) !== -1
                        },
                        on: {
                          select: _vm.selectVehicle,
                          tagPopupModal: _vm.tagPopupModal
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm._l([1, 2, 3, 4, 5, 6, 7, 8], function(vehicle) {
                      return _c("div", {
                        staticClass: "single-result-search none"
                      })
                    })
                  ]
                : _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _vm.loading
                        ? [
                            _vm._v(
                              "\n                        Loading...\n                    "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n                        No recommended vehicles found.\n                    "
                            )
                          ]
                    ],
                    2
                  )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bottom-container-result d-flex flex-wrap justify-content-end"
            },
            [
              _vm.total > 0
                ? _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.total,
                      "per-page": _vm.per_page
                    },
                    model: {
                      value: _vm.current_page,
                      callback: function($$v) {
                        _vm.current_page = $$v
                      },
                      expression: "current_page"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("favourite-tag-modal", {
        attrs: { vehicleId: _vm.vehicle_id },
        on: { changed: _vm.onTagChanged },
        model: {
          value: _vm.favListModalOpen,
          callback: function($$v) {
            _vm.favListModalOpen = $$v
          },
          expression: "favListModalOpen"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "left" }, [_c("h2", [_vm._v("Recommended")])])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-253f728e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-253f728e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyRecommendations/RecommendedPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-253f728e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MyRecommendations/RecommendedPage.vue
// module chunks = 0